import { useState, type ReactNode } from 'react';

/**
 * Tikla-ac kabuk (spec §3): KAPALI baslar ve kapaliyken cocugu MOUNT ETMEZ — cocugun sorgusu acilana
 * kadar hic calismaz (ilk acilis 7 istek butcesi, §4.4). Telefonda da kapali baslar.
 *
 * TEK CERCEVE: kabugun kendisi (`bg-surface border border-border rounded-lg`) TEK karttir. C4'un dort
 * cocugu (Isi/Sepet/Stok/KarKoprusu blok) kendi `SectionCard`'ini ciziyor ama ARTIK kendi `title`
 * PROP'unu GECMIYOR (bkz. IsiHaritasiBlok/SepetBlok/StokSatisBlok/KarKoprusuBlok) — kabugun `baslik`i
 * zaten ayni bilgiyi bir kez basiyor; ikinci bir baslik metni URETILMEZ (DOM'da hic yer almaz, CSS ile
 * gizlenmez). Govde `[&_section]:border-0 [&_section]:rounded-none [&_section]:shadow-none` ile
 * cocugun SectionCard cercevesini (kenarlik/yuvarlatma/golge) bastirir — kalan tek gorsel cerceve
 * kabuguninkidir. `border-t` govde ile dugme arasina TEK ayrac cizgisi ekler (cocugun kendi
 * cercevesi yoksa gorsel kopukluk olmasin diye); `p-3` YOK — ic icerik kendi `SectionCard` govde
 * dolgusunu (`p-5`, header `px-5 py-3.5`) zaten tasiyor, ikinci bir dolgu eklemek fazladan bosluk
 * birakirdi. `subtitle`/notlar (KapsamNotu, "kanal süzgeci uygulanmaz" vb.) SectionCard'ta KALIR —
 * `SectionCard` artik `subtitle` tek basina (title olmadan) da basiyor (primitives.tsx).
 */
export function TiklaAc({
  anahtar,
  baslik,
  altBaslik,
  children,
}: {
  anahtar: string;
  baslik: string;
  altBaslik?: string;
  children: ReactNode;
}) {
  const [acik, setAcik] = useState(false);
  return (
    <section data-testid={`tikla-ac-${anahtar}`} className="bg-surface border border-border rounded-lg">
      <button
        type="button"
        data-testid={`tikla-ac-${anahtar}-dugme`}
        aria-expanded={acik}
        onClick={() => setAcik((a) => !a)}
        className="focus-ring w-full flex items-center justify-between gap-3 px-5 py-3.5 text-left"
      >
        <span className="min-w-0">
          <span className="block text-[14px] font-semibold text-ink-900 leading-tight">{baslik}</span>
          {altBaslik && <span className="block text-[12px] text-ink-500 mt-0.5">{altBaslik}</span>}
        </span>
        <span aria-hidden="true" className="text-ink-500 shrink-0">{acik ? '▲' : '▼'}</span>
      </button>
      {acik && (
        <div
          data-testid={`tikla-ac-${anahtar}-govde`}
          className="border-t border-border [&_section]:border-0 [&_section]:rounded-none [&_section]:shadow-none"
        >
          {children}
        </div>
      )}
    </section>
  );
}
